import {
  CHOSEN_NEW_EXP_TEST,
  NEW_EXP_CHOSEN,
  OLD_EXP_CHOSEN,
  // TODO: Cleanup:StreamlinedOnboarding
  ONBOARDING_STREAMLINED_TEST,
  ONBOARDING_VARIANT,
  ONE_DOLLAR_BILLING_THRESHOLD,
  ONE_DOLLAR_BILLING_THRESHOLD_ENABLED,
} from '~/constants/ab-testing';
import { createSelector } from 'reselect';
import { getFeatureTestStore } from '~/selectors/feature-tests.selectors';

// TODO: Cleanup:ExpChosen
export const getIsAnyExpChosen = createSelector(getFeatureTestStore, (featureTests): boolean => {
  const newExpChosenVariant = featureTests.testVariantByFeature[CHOSEN_NEW_EXP_TEST];
  return !!newExpChosenVariant;
});

// TODO: Cleanup:ExpChosen
export const getIsNewExpChosen = createSelector(getFeatureTestStore, (featureTests): boolean => {
  const newExpChosenVariant = featureTests.testVariantByFeature[CHOSEN_NEW_EXP_TEST];
  return !!newExpChosenVariant && newExpChosenVariant.name === NEW_EXP_CHOSEN;
});

// TODO: Cleanup:ExpChosen
export const getIsOldExpChosen = createSelector(getFeatureTestStore, (featureTests): boolean => {
  const newExpChosenVariant = featureTests.testVariantByFeature[CHOSEN_NEW_EXP_TEST];
  return !!newExpChosenVariant && newExpChosenVariant.name === OLD_EXP_CHOSEN;
});

// TODO: Cleanup:StreamlinedOnboarding
export const getIsInStreamlinedOnboarding = createSelector(
  getFeatureTestStore,
  (featureTests): boolean =>
    isInTestVariant(featureTests)(ONBOARDING_STREAMLINED_TEST, ONBOARDING_VARIANT),
);

// TODO: Cleanup:OneDollarBillingThreshold
export const getIsInOneDollarBillingThresholdVariant = createSelector(
  getFeatureTestStore,
  (featureTests): boolean =>
    isInTestVariant(featureTests)(
      ONE_DOLLAR_BILLING_THRESHOLD,
      ONE_DOLLAR_BILLING_THRESHOLD_ENABLED,
    ),
);

export const getAllFeatureTestVariantNames = createSelector(
  getFeatureTestStore,
  (featureTests): readonly string[] =>
    featureTests.testVariants.reduce((variantNames, featTest) => {
      return [...variantNames, featTest.featureTestVariant.name];
    }, [] as string[]),
);

const isInTestVariant = (featureTests) => (testName, variantName) => {
  const userVariant = featureTests.testVariantByFeature[testName];
  return !!userVariant && userVariant.name === variantName;
};
